import _slicedToArray from '@babel/runtime/helpers/slicedToArray';

var __rest =
    (this && this.__rest) ||
    function(s, e) {
        var t = {};

        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === 'function')
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
            }
        return t;
    };

import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace, testColor, oneOf} from '../../common/utils';

var _createNamespace = createNamespace('tag'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export var TagColor = ['pink', 'pink-light', 'pink-dark', 'yellow', 'green', 'gray', ''];
export var TagSize = ['tiny', 'small', 'large', ''];
export var TagShape = ['square', 'circle', 'fillet', 'coupon', 'mark', ''];
export var TagType = ['plain', 'fill', ''];
export var TagSharp = ['top-left', 'top-right', 'bottom-left', 'bottom-right', ''];
export default {
    name: getComponentName('Tag'),
    props: {
        size: {
            type: String,
            validator: function validator(value) {
                return oneOf(value, [].concat(TagSize));
            },
            default: ''
        },
        shape: {
            type: String,
            validator: function validator(value) {
                return oneOf(value, [].concat(TagShape));
            },
            default: ''
        },
        type: {
            type: String,
            validator: function validator(value) {
                return oneOf(value, [].concat(TagType));
            },
            default: ''
        },
        fillColor: {
            type: String,
            validator: function validator(value) {
                return oneOf(value, [].concat(TagColor)) || testColor(value);
            },
            default: ''
        },
        color: {
            type: String,
            validator: function validator(value) {
                return oneOf(value, [].concat(TagColor)) || testColor(value);
            },
            default: ''
        },
        sharp: {
            type: String,
            default: ''
        },
        fontColor: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleClick: function handleClick() {
            this.$emit('click');
        }
    },
    render: function render() {
        var h = arguments[0];

        var _a = this,
            _b = _a.$props,
            sharp = _b.sharp,
            fontColor = _b.fontColor,
            fillColor = _b.fillColor,
            props = __rest(_b, ['sharp', 'fontColor', 'fillColor']),
            $slots = _a.$slots;

        var classes = [];

        for (var key in props) {
            props[key] && classes.push(props[key]);
        }

        fillColor && !testColor(fillColor) && classes.push(fillColor);
        return h(
            'span',
            {
                class: [b([classes, !!sharp && sharp.split(',')])],
                on: {
                    click: this.handleClick
                },
                style: {
                    background: testColor(fillColor) && fillColor,
                    color: testColor(fontColor) && fontColor
                }
            },
            [
                props.shape === 'coupon'
                    ? h(
                          'span',
                          {
                              class: 'text'
                          },
                          [' ', $slots.default && $slots.default, ' ']
                      )
                    : $slots.default && $slots.default
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
